module.exports = __webpack_public_path__ + "static/media/EPB2.73ed8c3c.png";